import { gql } from "@apollo/client";
import { darken } from "@mui/material";
import { COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import React from "react";

export const PotwCompetitionBannerFragment = gql`
  fragment PotwCompetitionBannerFragment on PotwCompetition {
    id
    name
    completed
    competitionType
    startDate
    endDate
    org {
      id
      name
    }
  }
`;

export default function PotwCompetitionBanner({ potwCompetition }) {
  const colorDarken = darken(COLOR_BLACK_LIGHTER, 0.5);

  return (
    <div
      style={{
        background: `linear-gradient(130deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
        color: COLOR_WHITE,
        fontWeight: 500,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: 14,
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 30,
        padding: 10,
        textTransform: "uppercase",
        position: "relative",
      }}
    >
      <div>
        <div style={{ marginBottom: 10 }}>{potwCompetition?.name}</div>
        <div style={{ fontSize: "0.8em", opacity: 0.8 }}>{potwCompetition?.org.name}</div>
      </div>
    </div>
  );
}
